var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { GoalPlannerTemplate } from '@/models/GoalPlannerTemplate';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Prop, Vue } from 'vue-property-decorator';
let CreateOrEditGoalPlannerTemplateDialog = class CreateOrEditGoalPlannerTemplateDialog extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.template = null;
        this.isLoading = true;
        this.templateTypeItems = [
            {
                label: this.$tc('Day'),
                value: 'day',
            },
            {
                label: this.$tc('Week'),
                value: 'week',
            },
        ];
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeTemplate();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onSubmit() {
        if (!this.template) {
            return;
        }
        const payload = {
            title: this.template.title,
            type: this.template.type,
        };
        if (this.isEditing) {
            this.onUpdateTemplate(payload);
        }
        else {
            this.onCreateTemplate(payload);
        }
    }
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.template = new GoalPlannerTemplate();
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateTemplate(payload) {
        if (!this.template || !this.isValid) {
            return;
        }
        try {
            await this.existingTemplate.update(payload);
            this.$emit('goalPlannerTemplateUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateTemplate(payload) {
        if (!this.template || !this.isValid) {
            return;
        }
        try {
            await new GoalPlannerTemplate().create(payload);
            this.$emit('goalPlannerTemplateCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeTemplate() {
        if (this.existingTemplate) {
            this.template = this.existingTemplate;
        }
        else {
            this.template = new GoalPlannerTemplate();
        }
    }
    // #endregion
    // #region Getters & Setters
    get isValid() {
        return (this.template !== null &&
            !!this.template.title &&
            this.template.title.trim() !== '' &&
            !!this.template.type);
    }
    get isEditing() {
        return !!this.existingTemplate;
    }
    get title() {
        return this.isEditing
            ? this.$tc('Edit period planner template')
            : this.$tc('Add period planner template');
    }
};
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof GoalPlannerTemplate !== "undefined" && GoalPlannerTemplate) === "function" ? _a : Object)
], CreateOrEditGoalPlannerTemplateDialog.prototype, "existingTemplate", void 0);
CreateOrEditGoalPlannerTemplateDialog = __decorate([
    Component({})
], CreateOrEditGoalPlannerTemplateDialog);
export default CreateOrEditGoalPlannerTemplateDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
